import { RootState } from "@/store";

export const selectThemeMode = (state: RootState): "light" | "dark" | "auto" => state.ui.themeMode;
export const selectSidebarOpen = (state: RootState): boolean => state.ui.sidebarOpen;
export const selectNotice = (state: RootState): string | null => state.ui.notice;
export const selectError = (state: RootState): string | null => state.ui.error;
